import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/** Create a new POS settlement */
export const createPosSettlement = async (payload) => {
  const res = await axios.post(`${BASE}/pos/settlements`, payload);
  return res.data;
};

/** List all POS settlements */
export const listPosSettlements = async () => {
  const res = await axios.get(`${BASE}/pos/settlements`);
  return res.data;
};

/** Get a single settlement by ID */
export const getPosSettlement = async (id) => {
  const res = await axios.get(`${BASE}/pos/settlements/${id}`);
  return res.data;
};

/** Delete a settlement */
export const deletePosSettlement = async (id) => {
  const res = await axios.delete(`${BASE}/pos/settlements/${id}`);
  return res.data;
};
